import React from "react";
import TeamCarousel from "./TeamCarousel";
import styles from "../About/About.module.css";

const Team = ({ isTestemonials }) => {
  return (
    <section className={styles.container} id="about">
      <div className={styles.textwithlines}>
        <div className={styles.line}></div>
        <h2 className={styles.title}>
          {isTestemonials ? "TESTIMONIALS" : "TEAM"}
        </h2>
        <div className={styles.line}></div>
      </div>
      <div className={styles.content}>
        <TeamCarousel isTestemonials={isTestemonials} />
      </div>
    </section>
  );
};

export default Team;
